export var RetryStates = /*#__PURE__*/ function(RetryStates) {
    RetryStates["RetryStarted"] = "Retry_Started";
    RetryStates["RetrySucceeded"] = "Retry_Succeeded";
    return RetryStates;
}({});
export var ConvivaConnectionType = /*#__PURE__*/ function(ConvivaConnectionType) {
    ConvivaConnectionType["WIRED"] = "Ethernet";
    ConvivaConnectionType["WIRELESS"] = "WiFi";
    ConvivaConnectionType["CELLULAR_2G"] = "2G";
    ConvivaConnectionType["CELLULAR_3G"] = "3G";
    ConvivaConnectionType["CELLULAR_4G"] = "4G";
    ConvivaConnectionType["UNKNOWN"] = "Unknown";
    return ConvivaConnectionType;
}({});

//# sourceMappingURL=conviva-addon.enums.js.map